import React from "react";
import { Scissors, Utensils, Wrench, Zap, Leaf, Car, Store, Check } from "lucide-react";
import { useWizard, BUSINESS_TYPES } from "../../lib/wizardStore";

const ICONS = { scissors: Scissors, utensils: Utensils, wrench: Wrench, zap: Zap, leaf: Leaf, car: Car, store: Store };

export default function BusinessTypeStep() {
  const { state, setBusinessType } = useWizard();
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          What kind of business is this?
        </h2>
        <p className="text-slate-500 mt-2">
          This helps customers find you in the right Google category.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {BUSINESS_TYPES.map((bt) => {
          const Icon = ICONS[bt.icon] || Store;
          const active = state.businessType === bt.id;
          return (
            <button
              key={bt.id}
              data-testid={`business-type-${bt.id}`}
              onClick={() => setBusinessType(bt.id)}
              className={`relative text-left rounded-2xl border p-4 transition-all ${
                active
                  ? "border-emerald-500 bg-emerald-50/60 ring-4 ring-emerald-500/10"
                  : "border-slate-200 bg-white hover:border-slate-300 hover:-translate-y-0.5"
              }`}
            >
              {active && (
                <div className="absolute top-3 right-3 w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center">
                  <Check className="w-3 h-3" />
                </div>
              )}
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${
                  active ? "bg-emerald-500 text-white" : "bg-slate-100 text-slate-700"
                }`}
              >
                <Icon className="w-5 h-5" />
              </div>
              <div className="font-medium text-slate-900">{bt.label}</div>
              <div className="text-xs text-slate-500 mt-0.5">{bt.category}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
